"use strict";

exports.__esModule = true;
var _NavigationFrame = require("./NavigationFrame");
Object.keys(_NavigationFrame).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NavigationFrame[key]) return;
  exports[key] = _NavigationFrame[key];
});